'use strict';

var processInclude = require('./util');

$(function () {
    processInclude(require('./product/giftCardProduct'));
    processInclude(require('./product/wishlistHeart'));
    processInclude(require('./product/wishlist'));
    processInclude(require('capencyBase/capency/email/capemail'));
});
